// @core/api/endpoints/bootstrap/acknowledge_vault_keys.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcknowledgeVaultKeysRequest,
  AcknowledgeVaultKeysResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Acknowledge vault keys saved
 * Confirms that the admin has saved the unseal keys and root token. Execution continues to the next step. This is a critical security checkpoint — unseal keys are never shown again.
 * @public This endpoint does not require authentication
 */
export async function AcknowledgeVaultKeys(
  data: AcknowledgeVaultKeysRequest,
  options?: RequestOptions
): Promise<AcknowledgeVaultKeysResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/vault/acknowledge`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<AcknowledgeVaultKeysResponse>(requestPath, data, requestOptions);
}
